import React from "react";
import image1 from "../../assets/images/product-detail/persons/GASTOS_MÉDICOS.png";
import image2 from "../../assets/images/product-detail/persons/HOGAR_S2.png";
import image3 from "../../assets/images/product-detail/persons/SALUD_S2.png";
import image4 from "../../assets/images/product-detail/persons/RC_S2.png";

export const ProductDetailFormTitle = [
	{
		id: "automovil",
		title: <h5 className='text-center mb-1'>Sabemos lo importante &nbsp;</h5>,
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					<span className='text-primary'>que es tu coche para ti</span>
				</strong>
			</h4>
		),
	},
	{
		id: "flotilla",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'></span>{" "}
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					<span className='text-primary'>Protegemos tus autos,</span>
					&nbsp;así como tus conductores.
				</strong>
			</h4>
		),
	},
	{
		id: "medical-expense",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'></span>{" "}
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
	{
		id: "medical-expense-group",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>Salud para toda la empresa.</span>
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					Sabemos de lo importante que es para ti cuidar de los tuyos.&nbsp;{" "}
					<span className='text-primary'>Asesoría en análisis de riesgo</span>
				</strong>
			</h4>
		),
	},
	{
		id: "vida",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
	{
		id: "vida-grupo",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>Tranquilidad </span>
				&nbsp;para tus colaboradores.
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					Sabemos lo importante &nbsp;{" "}
					<span className='text-primary'>
						que es para ellos cuidar de los suyos.
					</span>
				</strong>
			</h4>
		),
	},
	{
		id: "accident",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
	{
		id: "company_accident",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>La mejor protección </span>
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>&nbsp;al menor costo.</strong>
			</h4>
		),
	},
	{
		id: "hogar",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},

	{
		id: "responsabilidad",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
	{
		id: "tractocamiones",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del&nbsp; <span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
	{
		id: "empresarial",
		title: (
			<h5 className='text-center mb-1'>
				<span className='text-primary'>i8 años</span>
				&nbsp;en México como
			</h5>
		),
		subTitle: (
			<h4 className='text-center mb-4'>
				<strong>
					lider del &nbsp;<span className='text-primary'>mercado digital!</span>
				</strong>
			</h4>
		),
	},
];

const products = [
	{
		img: image1,
		title1: "Tranquilidad",
		title2: "en tu vida",
		text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
		id: "accidents",
	},
	{
		img: image2,
		title1: "Tranquilidad",
		title2: "en tu vida",
		text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
		id: "hogar",
	},
	{
		img: image3,
		title1: "Tranquilidad",
		title2: "en tu vida",
		text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
		id: "salud",
	},
	{
		img: image4,
		title1: "Tranquilidad",
		title2: "en tu vida",
		text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
		id: "civil",
	},
];

export default products;
